import { Icon, Theme, WithStyles, withStyles } from '@material-ui/core';
import { CSSProperties } from '@material-ui/core/styles/withStyles';
import React, { ReactNode } from 'react';
import { Coords } from 'google-map-react';

const styles = (theme: Theme) => ({
    marker: {
        color: 'red',
        
        // this setting are important in order to set the edge of the pin on the correct place
        position: 'absolute', 
        top: -21, 
        left: -12
    } as CSSProperties
})

interface __Props {
    location?: Coords
    renderMarker: () => ReactNode
}

export class __Marker extends React.Component<__Props> {
    render() {
        const { location, renderMarker } = this.props;

        return location ? renderMarker() : null
    }
}

interface Props extends WithStyles<typeof styles> {
    location?: Coords
    lat: number
    lng: number
}

class Marker extends React.Component<Props> {
    renderMarker = () => {
        const { classes } = this.props;

        return <Icon className={classes.marker}>location_on</Icon>
    }

    render() {
        const { location } = this.props;

        // eslint-disable-next-line
        return <__Marker 
            renderMarker={this.renderMarker}
            location={location}
        />
    }
}

export default withStyles(styles)(Marker);